/* eslint-disable no-restricted-syntax */
/* eslint-disable radix */
/* eslint-disable lodash/prefer-constant */
/* This template mostly is the copy from  Eughteenth inch Drop down  Component */

import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import noop from 'lodash/noop';
import camelCase from 'lodash/camelCase';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import HowToMeasure from '../../components/HowToMeasure';
import ChoiceSectionHeaderV2 from '../../components/ChoiceSectionHeader/v2';
// eslint-disable-next-line import/no-cycle
import store from '../../store/store';

const EighthInchDropdownWrapper = styled.div`
  margin: -10px -10px 0px -10px;
  @media (max-width: 767px) {
    div[class^="styles__Wrapper"] {
      min-width: 50%;
      box-sizing: border-box;
    }
  }
`;

function WithCustomSizing(DropDownComponent, templateName = 'SixteenInchDropdown') {
  function CustomSize({
    attributes,
    option,
    choices: [choice],
    dropdownChoices,
    onChoiceSelected,
    onChoicesSelected,
    onChoiceSelectedSuccess,
  }) {
    const getDefinition = () => attributes[camelCase('HowToMeasure')];// Create bool from string
    const { defaultSizesWidthHeight = '' } = attributes || '';

    const [defaultWidth, defaultHeight] = defaultSizesWidthHeight && defaultSizesWidthHeight.split(':');

    const handleChange = useCallback((inch, eighth) => {
      const choiceValue = (Number.isNaN(inch) ? Number(choice.minValue) : inch)
      + (Number.isNaN(eighth) ? Number(0) : eighth);

      // Adding logic to select same hidden width choice which is selected from UI dropdown for stock blinds
      if (option.presentationName === 'EighthInchDropdown') {
        const { configurator: { options, choices } } = store.getState();
        const hiddenWidthOption = filter(options, (op) => op.optionType === 'HiddenWidth');
        if (hiddenWidthOption.length > 0) {
          let isFoundChoiceValue = false;
          for (const ch of Object.entries(choices)) {
            if (ch[1].optionId === hiddenWidthOption[0].id && (ch[1].value === `_${choiceValue}`) && !ch[1].isSelected) {
              isFoundChoiceValue = true;
              onChoiceSelected(hiddenWidthOption[0].id, ch[1].id, ch[1].value).then(() => onChoiceSelectedSuccess());
            }
          }
          if (!isFoundChoiceValue) {
            for (const ch of Object.entries(choices)) {
              if (ch[1].optionId === hiddenWidthOption[0].id && (ch[1].value === `_${inch}`) && !ch[1].isSelected) {
                isFoundChoiceValue = true;
                onChoiceSelected(hiddenWidthOption[0].id, ch[1].id, ch[1].value).then(() => onChoiceSelectedSuccess());
              }
            }
          }
        }
      }

      onChoiceSelected(option.id, choice.id, choiceValue).then(() => onChoiceSelectedSuccess());
    }, [option, choice, onChoiceSelected]);

    useEffect(() => {
      if (!isEmpty(dropdownChoices) && !isEmpty(attributes)) {
        const dropChoices = Object.values(dropdownChoices);
        let initialDropDownChoices = [];
        dropChoices.forEach((c) => {
          if (c.parentOptionType === 'Width') {
            initialDropDownChoices.push({ ...c, choiceValue: parseInt(defaultWidth) || c.minValue, choiceId: c.id });
          } else if (c.parentOptionType === 'Height') {
            initialDropDownChoices.push({ ...c, choiceValue: parseInt(defaultHeight) || c.minValue, choiceId: c.id });
          }
        });
        Promise.resolve(onChoicesSelected(initialDropDownChoices));
      }
    }, [attributes]);

    let wholeDropdown;
    let fractionalDropdown;
    let singleLabelOnly = true;
    if (templateName === 'EighthInchDropdown') {
      const label = (option && option.shortLabel) || '';
      const value = (choice && choice.value) || 0;
      wholeDropdown = { label, value: parseInt(value) };
      fractionalDropdown = { label: label.replace('(in.)', '(eighths)'), value: value - parseInt(value) };
      singleLabelOnly = false;
    }

    return (
      <>
        {option && (option.optionType === 'Width' || option.tags.includes('HowToMeasure')) && (
          <HowToMeasure
            label={option && option.shortLabel}
            definitionHeader="How to Measure:"
            definitionMarkdown={getDefinition()}
          />
        )}
        <div style={{ marginTop: '20px' }}>

          {singleLabelOnly && <ChoiceSectionHeaderV2 label={option && option.shortLabel} />}

          {/* Styling to adjust left and right margins */}
          <EighthInchDropdownWrapper>
            <DropDownComponent
              value={choice.value}
              minValue={Math.floor(choice.minValue)}
              maxValue={Math.floor(choice.maxValue)}
              onChange={handleChange}
              whole={wholeDropdown}
              fractional={fractionalDropdown}
            />
          </EighthInchDropdownWrapper>
        </div>
      </>
    );
  }

  CustomSize.propTypes = {
    option: PropTypes.object.isRequired,
    choices: PropTypes.array.isRequired,
    attributes: PropTypes.object.isRequired,
    onChoiceSelected: PropTypes.func.isRequired,
    onChoicesSelected: PropTypes.func.isRequired,
    onChoiceSelectedSuccess: PropTypes.func.isRequired,
    dropdownChoices: PropTypes.array.isRequired,
  };

  return CustomSize;
}

export default WithCustomSizing;
